import { useContext } from 'react';

import { ArticlesModuleContext } from '../../context/articles-module-context/article-module-context';

export const useArticlesModuleContext = () => {
  const context = useContext(ArticlesModuleContext);
  if (!context) {
    throw new Error(
      'useArticlesModuleContext must be used within a ArticlesModuleContextProvider'
    );
  }
  return context;
};
